import { Component, OnInit, Input } from '@angular/core';
import { Comment } from '../../../api/models/comment';
import { AuthService } from '../../../api/services/auth.service';
import { CommentService } from '../../../api/services/comment.service';
import { FilesModalComponent } from '../../comments/files-modal/files-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreviewImageComponent } from '../../preview-image/preview-image.component';

@Component({
  selector: 'app-bom-comment',
  templateUrl: './bom-comment.component.html',
  styleUrls: ['./bom-comment.component.scss']
})
export class BomCommentComponent implements OnInit {

  @Input() id: string;

  @Input() context: string;

  hasItemComment: boolean;
  hasWarehouseComment: boolean;
  creatingComment = false;
  itemBody: string;
  warehouseBody: string;
  commentText: string;
  type: string;
  itemComment: Comment;
  warehouseComment: Comment;

  contextText: 'Order' | 'Item';

  loading = true;

  fileIds: string[] = [];

  constructor(private commentService: CommentService,
    private authService: AuthService,
    private modalService: NgbModal
  ) { }

  getComments() {
    this.commentService.getComments(`${this.context}~${this.id}`).subscribe(comments => {
      if (comments.length > 0) {
        this.itemComment = comments.find(c => c.commentType === 'itemComment');
        this.warehouseComment = comments.find(c => c.commentType === 'warehouseComment');

        this.itemComment ? (this.hasItemComment = true, this.itemBody = this.itemComment.body, this.fileIds = this.itemComment.fileIds)
          : this.hasItemComment = false;

        this.warehouseComment ? (this.hasWarehouseComment = true, this.warehouseBody = this.warehouseComment.body)
          : this.hasWarehouseComment = false;
      } else {
        this.hasItemComment = false;
        this.hasWarehouseComment = false;
      }

      this.loading = false;
    });
  }

  ngOnInit() {
    this.contextText = this.context === 'BOM' ? 'Order' : 'Item';
    this.getComments();
  }

  openFilesModal() {
    const modalRef = this.modalService.open(FilesModalComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.type = 'Add';

    modalRef.result.then(result => {
      this.fileIds = result;
    });
  }

  previewFile(fileId: string) {
    const modalRef = this.modalService.open(PreviewImageComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.fileId = fileId;

    modalRef.result.then(() => { })
      .catch(() => { });
  }

  createComment(type: string) {
    const newComment: Comment = {
      universalObjectString: `${this.context}~${this.id}`,
      commenterUserId: this.authService.getUserId(),
      body: this.commentText,
      commentType: type,
      fileIds: type === 'itemComment' ? this.fileIds : [],
      updatedBy: null
    };

    this.commentService.createComment(newComment).subscribe(() => {
      type === 'itemComment' ? this.hasItemComment = true : this.hasWarehouseComment = true;
      this.creatingComment = false;
      this.commentText = '';
      this.getComments();
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/bom-table/bom-comment/bom-comment.component.ts